import React from 'react';
import PropTypes from 'prop-types';
import {useDispatch, useSelector} from 'react-redux';

import {removeModal} from '../store/app';
import Drawer from 'react-drag-drawer';
import Icon from './Icons';
import Text from './uiElem/Text';

function Modal(props) {
  const {
    id,
    header,
    children,
    footer,
    width,
    allowClose,
    reqCloseCallback,
    invoiceNumber,
    noInvoiceNumberCallback,
    showCloseBtn,
  } = props;

  const dispatch = useDispatch();
  const modalInStore = useSelector(state => state.app.modal);
  const isModalOpen = modalInStore === id;

  const handleRequestClose = () => {
    reqCloseCallback(id);
    !Boolean(invoiceNumber) && noInvoiceNumberCallback();

    return dispatch(removeModal());
  };

  if (!isModalOpen) {
    return [];
  }

  return (
    <Drawer
      open={isModalOpen}
      onRequestClose={allowClose ? () => {} : handleRequestClose}
      modalElementClass={`text-14 relative bg-white rounded shadow m-4 max-h-full w-full overflow-y-auto ${
        width ?? 'md:w-3/5'
      }`}
      allowClose={allowClose}>
      {!!header && (
        <div className="border-b p-4 text-left flex items-center justify-between">
          <div className={`flex-grow ${!allowClose ? 'text-center' : ''}`}>
            <Text ui="mars">{header}</Text>
          </div>

          {(allowClose || showCloseBtn) && (
            <div className="pl-4 flex-no-grow flex-no-shrink">
              <div className="cursor-pointer" onClick={handleRequestClose}>
                <Icon name="CloseButton" grey />
              </div>
            </div>
          )}
        </div>
      )}

      {children}
      {footer}
    </Drawer>
  );
}

Modal.propTypes = {
  id: PropTypes.string.isRequired,
  header: PropTypes.node,
  children: PropTypes.node.isRequired,
  footer: PropTypes.node,
};

Modal.defaultProps = {
  header: null,
  footer: null,
  children: null,
  reqCloseCallback: () => {},
  noInvoiceNumberCallback: () => {},
};

export default Modal;
